import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import arrow from "../../Assets/Images/Icons/right-arrow.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "../../Assets/Styles/Home/swiper.css";

// import required modules
import { Navigation } from "swiper";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className=" z-10">
      <>
        <Swiper navigation={true} modules={[Navigation]} className="heroSwiper">
          <SwiperSlide>
            <div className="heroSection">
              <div className="max-xl:flex justify-between pl-5  max-sm:pl-10 max-xl:pl-0 max-xl:gap-x-[620px]  max-w-[1200px] max-xl:mx-auto	">
                <div>
                  <span className="bg-[#fff] rounded-[30px] max-sm:px-8 mb-5   w-[240px]  max-sm:w-[330px] leading-10 block text-base  max-sm:text-[22px] font-bold font-roboto">
                    <span className="text-linear-gradient">
                      {" "}
                      We are IT service agency ~
                    </span>
                  </span>

                  <h1 className="text-[#fff] max-sm:text-[45px] text-[28px]  max-md:text-[65px] text-left font-bold font-fira  leading-[40px] max-md:leading-[80px] max-sm:leading-[60px]">
                    We make visionary <br /> ideas come to life.
                  </h1>
                  <p className="font-roboto  text-[#fff] text-[18px] opacity-[0.78] pr-5 max-sm:pr-0 max-sm:w-[500px] text-justify  mt-5 mb-6">
                    IT Ghar works in several IT sectors with a skilled
                    workforce. We have dedicated & highly experienced
                    professionals to provide whole IT services and solutions.
                  </p>
                  <Link to="/contact">
                    <button
                      style={{ boxShadow: "none" }}
                      className="custom_button flex justify-center items-center "
                    >
                      {" "}
                      Contact Us{" "}
                      <img className="ml-2" src={arrow} alt="IT Ghar" />{" "}
                    </button>
                  </Link>
                </div>
                <div></div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="heroSection heroSection2">
              <div className="max-xl:flex justify-between pl-5  max-sm:pl-10 max-xl:pl-0 max-xl:gap-x-[510px]  max-w-[1200px] max-xl:mx-auto	">
                <div>
                  <span className="bg-[#fff] mb-10  rounded-[30px] max-sm:px-8  text-[#FF0000] w-[240px]  max-sm:w-[330px] leading-10 block text-base  max-sm:text-[22px] font-bold font-roboto">
                    We are IT service agency ~
                  </span>

                  <h1 className="text-[#fff] max-sm:text-[45px] text-[28px]  max-md:text-[75px] text-left font-bold font-fira  leading-[40px] max-md:leading-[80px] max-sm:leading-[60px]">
                    Tailored IT Services
                    <br />
                    Your Unique Needs.
                  </h1>
                  <p className="font-roboto text-[#fff] text-xl pr-5 max-sm:pr-0 max-sm:w-[500px] text-left mt-5 mb-6">
                    Comprehensive IT services for modern businesses. Cloud
                    computing, cybersecurity, infrastructure management, and
                    more.
                  </p>
                  <Link to="/contact">
                    <button
                      style={{ boxShadow: "none" }}
                      className="custom_button flex justify-center items-center "
                    >
                      {" "}
                      Contact Us{" "}
                      <img className="ml-2" src={arrow} alt="IT Ghar" />{" "}
                    </button>
                  </Link>
                </div>
                <div></div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </>
    </section>
  );
};

export default HeroSection;
